import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=720e24bb&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=ts&"
export * from "./Onboarding.vue?vue&type=script&lang=ts&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=720e24bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e24bb",
  null
  
)

export default component.exports